import {getLocalizationBasedOnLang} from '../../data/models/User/UserInfo';

const english = {
  welcome: 'Welcome',
  inThisCourse: 'In this course',
  lessons: 'Lessons',
  minApprox: 'min. approx.',
  minutes: 'Minutes',
  minute: 'Minute',
  progressCompleted: 'completed',
  courses: 'Courses',
  readyForIt: 'Get started today',
  daysLeft: (amountOfDays: number) =>
    `${amountOfDays === 1 ? 'day' : 'days'} left`,
  lessonsAmount: (amountOfLessons: number) =>
    `${amountOfLessons === 1 ? 'lesson' : 'lessons'}`,
  continue: 'Start lesson',
  start: 'Enroll now',
  expired: 'Expired',
  noDueDate: 'No due date',
  microreelChip: 'Continue on microreels app',
  completed: 'Completed',
};

const welsh = {
  welcome: 'Croeso',
  inThisCourse: 'Yn y cwrs hwn',
  lessons: 'Gwersi',
  minApprox: 'isaf. amcangyfrif.',
  minutes: 'Munudau',
  minute: 'Munud',
  progressCompleted: 'completed',
  courses: 'Cyrsiau',
  readyForIt: 'Dechreuwch heddiw',
  daysLeft: (amountOfDays: number) =>
    `${amountOfDays === 1 ? 'Dydd yn ar ôl' : 'Dyddiau yn ar ôl'}`,
  lessonsAmount: (amountOfLessons: number) =>
    `${amountOfLessons === 1 ? 'Gwers' : 'Gwersi'}`,
  continue: 'Dechreuwch y gwers',
  start: 'Cofrestrwch nawr',
  expired: 'Wedi dod i ben',
  noDueDate: 'Dim dyddiad gorffen',
  microreelChip: 'Microreel',
  completed: 'Wedi cwblhau',
};

export const courseHomeText: any = getLocalizationBasedOnLang(english, welsh);
